import { Component } from 'react';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
import { getMarketingConsent } from '../../actions/marketing_consent';
import CheckboxGroup from '../common/form/elements/checkbox-group';
import { getMarketingCategories } from '../../actions/marketing-category';

const styles = {
  paddingBottom: 30,
  textAlign: 'left'
};

class MarketingPreferences extends Component {
  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getMarketingCategories());

    if (!this.props.invitation) {
      let params = {};

      if (this.props.customer_number) {
        params = { params: { customer_unique_number: this.props.customer_number } };
      }

      dispatch(getMarketingConsent(params));
    }
  }

  optionsConfirm = [
    {
      label: (<strong>I've changed my mind, keep me updated</strong>),
      value: 'true',
    },
    {
      label: (<div style={ { fontSize: '0.9em' } }>No, I don't want to be kept up to date</div>),
      value: 'false',
    }
  ];

  marketingPreferences = (
    <div>
      You must update your contact preferences below so that we are able to keep you up to date with
      important <strong>ignite</strong> updates such as; ways of earning points, product pricing, competitions & prize draws and
      local POR deals.
      <br />
      <br />
      <strong>By opting out you may reduce your potential for earning maximum ignite points.</strong>
    </div>
  )

  render() {
    const {
      title, marketingConsentText, marketingConsentCondition, marketingCategories
    } = this.props;

    const options = marketingCategories.map(marketingCategory => ({ label: marketingCategory.name, value: marketingCategory.id }));

    let marketingPreferences = (
      <div>
        You must update your contact preferences below so that we are able to keep you up to date with
        important <strong>ignite</strong> updates such as; ways of earning points, product pricing, competitions & prize draws and
        local POR deals.
        <br />
        <br />
        <strong>By opting out you may reduce your potential for earning maximum ignite points.</strong>
      </div>
    );

    marketingPreferences = (
      <div className={marketingConsentCondition} >
        {
          (marketingConsentText) ? (
            <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(marketingConsentText)}}></div>
          ) : null
        }
      </div>
    );

    return (
      <div style={styles}>
        {title}
        {marketingPreferences}
        <br/>
        <CheckboxGroup model=".marketing_categories" controlId="marketing_categories" options={options} />
        <div>
          Please note that your marketing preferences will not impact ignite programme service notifications,
          we will still let you know about important updates and changes to the programme.
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  marketingConsentText: state.marketingConsents.marketingConsent.content,
  marketingConsentCondition: state.marketingConsents.marketingConsent.condition,
  marketingCategories: state.marketingCategories.marketingCategories
});

export default connect(mapStateToProps)(MarketingPreferences);
